// import React, { useEffect, useRef } from 'react';

// const CardzonePayment = () => {
//   const formRef = useRef(null);

//   useEffect(() => {

//     const loadTransaction = async () => {
//       let purchaseId = await JSON.parse(localStorage.getItem('purchaseId')) ;
//       let privateKeyPem = await JSON.parse(localStorage.getItem('privateKeyPem')) ;

//       try {
//         const res = await fetch('/prepare-transaction',{
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({ purchaseId,privateKeyPem }), // Send the cart items to the backend
//         });
//         const { formData } = await res.json();

//         const form = formRef.current;

//         // Clear any existing fields
//         form.innerHTML = '';

//         for (let key in formData) {
//           const input = document.createElement('input');
//           input.type = 'hidden';
//           input.name = key;
//           input.value = formData[key];
//           form.appendChild(input);
//         }

//         form.submit();
//       } catch (err) {
//         console.error('❌ Failed to prepare 3DS transaction', err);
//       }
//     };

//     loadTransaction();
//   }, []);

//   return (
//     <div>
//       <h2>Secure Payment Processing (3D Secure)</h2>
//       <iframe
//         name="cardzoneFrame"
//         title="Cardzone 3D Secure"
//         style={{ width: '100%', height: '600px', border: 'none' }}
//       ></iframe>

//       <form
//         ref={formRef}
//         method="POST"
//         action="https://3dsecure.bob.bt/3dss/mercReq"
//         target="cardzoneFrame"
//       ></form>
//     </div>
//   );
// };

// export default CardzonePayment;

// import React from 'react';

// const CardzonePayment = () => {
//   const handlePayment = async () => {
//     const purchaseId = JSON.parse(localStorage.getItem('purchaseId'));
//     const privateKeyPem = JSON.parse(localStorage.getItem('privateKeyPem'));
//     const mac = JSON.parse(localStorage.getItem('mac'));
// // console.log('📦 Preparing payment with purchaseId:', purchaseId, 'privateKeyPem:', privateKeyPem, 'mac:', mac);
//     if (!purchaseId || !privateKeyPem) {
//       alert('Missing purchaseId or privateKeyPem');
//       return;
//     }

//     try {
//       const res = await fetch('/prepare-transaction', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ purchaseId, privateKeyPem,mac })
//       });

//       const { formData } = await res.json();
//       console.log('📦 Received formData:', formData);

//       // Create real form
//       const form = document.createElement('form');
//       form.method = 'POST';
//       form.action = 'https://3dsecure.bob.bt/3dss/mercReq';
//       form.target="cardzoneFrame"

//       Object.entries(formData).forEach(([key, value]) => {
//         const input = document.createElement('input');
//         input.type = 'hidden';
//         input.name = key;
//         input.value = value;
//         form.appendChild(input);
//       });

//       document.body.appendChild(form);
//       form.submit(); // ⬅️ this should open a new tab now

//     } catch (err) {
//       console.error('❌ Payment error:', err);
//       alert('Payment failed: ' + err.message);
//     }
//   };

//   return (
//     <div>
//       <h2>Secure Payment with Cardzone</h2>
//       <button onClick={handlePayment}>Pay Now</button>
//     </div>
//   );
// };

// export default CardzonePayment;





// import React, { useState } from "react";

// const CardzonePayment = () => {


//     const [cardDetails, setCardDetails] = useState({
//     name: "",
//     number: "",
//     expiry: "",
//     cvc: "",
//   });

//   const handlePayment = async () => {
//     const purchaseId = JSON.parse(localStorage.getItem('purchaseId'));
//     const privateKeyPem = JSON.parse(localStorage.getItem('privateKeyPem'));
//     const amount = JSON.parse(localStorage.getItem('amount'));
//     const mac = JSON.parse(localStorage.getItem('mac'));

//     if (!purchaseId || !privateKeyPem) {
//       alert('Missing purchaseId or privateKeyPem');
//       return;
//     }

//     try {
//       const res = await fetch('/prepare-transaction', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ purchaseId, privateKeyPem, mac,cardDetails,amount })
//       });

//       const { formData } = await res.json();
//       console.log('📦 Received formData:', formData);

//       // Create and submit form
//       // const form = document.createElement('form');
//       // form.method = 'POST';
//       // form.action = 'https://3dsecure.bob.bt/3dss/mercReq';
//       // form.target = 'cardzoneFrame';

//       // Object.entries(formData).forEach(([key, value]) => {
//       //   const input = document.createElement('input');
//       //   input.type = 'hidden';
//       //   input.name = key;
//       //   input.value = value;
//       //   form.appendChild(input);
//       // });

//       // document.body.appendChild(form);
//       // form.submit();
//       // document.body.removeChild(form); // optional clean-up

//     } catch (err) {
//       console.error('❌ Payment error:', err);
//       alert('Payment failed: ' + err.message);
//     }
//   };


//   const handleChange = (e) => {
//     setCardDetails({ ...cardDetails, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log("Submitting card details:", cardDetails);

//     // You can replace this with actual payment logic
//     // like sending to backend or integrating with payment gateway
//   };


//   return (
//     <div>
//       <h2>Secure Payment with Cardzone</h2>
//       <div className="max-w-md mx-auto p-6 bg-white shadow-md rounded-xl mt-10">
//       <h2 className="text-2xl font-bold mb-6 text-center">Card Payment</h2>
//       {/* <h5 className="text-2xl font-bold mb-6 text-center">$ {amount}</h5> */}

//       <form onSubmit={handleSubmit} className="space-y-4">
//         <div>
//           <label className="block text-sm font-medium text-gray-700">Cardholder Name</label>
//           <input
//             type="text"
//             name="name"
//             value={cardDetails.name}
//             onChange={handleChange}
//             placeholder="John Doe"
//             required
//             className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-indigo-500"
//           />
//         </div>

//         <div>
//           <label className="block text-sm font-medium text-gray-700">Card Number</label>
//           <input
//             type="text"
//             name="number"
//             value={cardDetails.number}
//             onChange={handleChange}
//             placeholder="1234 5678 9012 3456"
//             maxLength="19"
//             required
//             className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-indigo-500"
//           />
//         </div>

//         <div className="grid grid-cols-2 gap-4">
//           <div>
//             <label className="block text-sm font-medium text-gray-700">Expiry Date</label>
//             <input
//               type="text"
//               name="expiry"
//               value={cardDetails.expiry}
//               onChange={handleChange}
//               placeholder="MM/YY"
//               maxLength="5"
//               required
//               className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-indigo-500"
//             />
//           </div>

//           <div>
//             <label className="block text-sm font-medium text-gray-700">CVC</label>
//             <input
//               type="text"
//               name="cvc"
//               value={cardDetails.cvc}
//               onChange={handleChange}
//               placeholder="123"
//               maxLength="4"
//               required
//               className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-indigo-500"
//             />
//           </div>
//         </div>

//         <button
//           className="w-full py-3 bg-indigo-600 text-white font-semibold rounded-md hover:bg-indigo-700 transition"
//                onClick={handlePayment}

//         >
//           Pay Now
//         </button>
//       </form>
//     </div>
//       {/* <button onClick={handlePayment}>Pay Now</button> */}

//       {/* Invisible or embedded iframe for 3DS form submission */}
//       <iframe
//         name="cardzoneFrame"
//         title="Cardzone 3DS Payment"
//         style={{ width: '100%', height: '500px', border: '1px solid #ccc' }}
//       />
//     </div>
//   );
// };

// export default CardzonePayment;






import React, { useState, useEffect } from 'react';
import Header from './Header';



const CardzonePayment = () => {
  const [cardDetails, setCardDetails] = useState({
    name: '',
    number: '',
    expiry: '',
    cvc: ''
  });

useEffect(() => {
const handlePayment = async () => {

      const storedAmount = await localStorage.getItem('amount');

  try {
    const keyExchangeRes = await fetch('/key-exchange', { method: 'POST' });
    const keyData = await keyExchangeRes.json();
    const { purchaseId, privateKeyPem, mac } = keyData.data;

    const transactionRes = await fetch('/prepare-transaction', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ purchaseId, privateKeyPem, mac, cardDetails, amount:storedAmount })
    });

    const { data, mac: generatedMac } = await transactionRes.json();

    const form = document.createElement('form');
    form.method = 'POST';
    form.action = 'https://3dsecure.bob.bt/3dss/mercReq';
    form.target = 'cardzoneFrame';

    Object.entries(data).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      form.appendChild(input);
    });

    // Append MAC separately
    const macInput = document.createElement('input');
    macInput.type = 'hidden';
    macInput.name = 'mac';
    macInput.value = generatedMac;
    form.appendChild(macInput);

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  } catch (err) {
    console.error('❌ Payment failed:', err);
    alert('Payment failed. Check console for details.');
  }
};

handlePayment();
  
},[])

// const handlePayment = async () => {
//   try {
//     const keyExchangeRes = await fetch('/key-exchange', { method: 'POST' });
//     const keyData = await keyExchangeRes.json();
//     const { purchaseId, privateKeyPem, mac } = keyData.data;

//     const transactionRes = await fetch('/prepare-transaction', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ purchaseId, privateKeyPem, mac, cardDetails, amount })
//     });

//     const { data, mac: generatedMac } = await transactionRes.json();

//     const form = document.createElement('form');
//     form.method = 'POST';
//     form.action = 'https://3dsecure.bob.bt/3dss/mercReq';
//     form.target = 'cardzoneFrame';

//     Object.entries(data).forEach(([key, value]) => {
//       const input = document.createElement('input');
//       input.type = 'hidden';
//       input.name = key;
//       input.value = value;
//       form.appendChild(input);
//     });

//     // Append MAC separately
//     const macInput = document.createElement('input');
//     macInput.type = 'hidden';
//     macInput.name = 'mac';
//     macInput.value = generatedMac;
//     form.appendChild(macInput);

//     document.body.appendChild(form);
//     form.submit();
//     document.body.removeChild(form);
//   } catch (err) {
//     console.error('❌ Payment failed:', err);
//     alert('Payment failed. Check console for details.');
//   }
// };

  return (

    <> 
    <Header></Header>
    <div className="mt-16 w-full   bg-white shadow-md rounded">
     
      <iframe
        name="cardzoneFrame"
        title="Cardzone Frame"
        style={{ width: '100%', height: '500px', border: '1px solid #ccc', marginTop: '20px' }}
      />
    </div>
    </>
   
  );
};

export default CardzonePayment;
